import {UserJourneyAndAttributes} from "../http/protocol";
import {UserJourneyAction, UserJourneyActionTypes} from "./UserJourneyActions";

export enum Status { NONE="NONE", LOADING ="LOADING", DONE ="DONE", ERROR="ERROR" }
export interface UserJourneyState {
    status?: Status;
    journey?: UserJourneyAndAttributes;
}


export function userJourneyReducer(state: UserJourneyState = { status : Status.NONE }, action : UserJourneyAction ) {
    if(action.type == UserJourneyActionTypes.REQUEST) {
        return {...state, status : Status.LOADING}
    } else if(action.type == UserJourneyActionTypes.RESPONSE) {
        return {...state, status: Status.DONE, journey : action.journey};
    } else if(action.type == UserJourneyActionTypes.ERROR) {
        return {...state, status: Status.ERROR }
    }
    return state;
}